import { IEnvironment } from './IEnvironment';
import packageJson from '../../package.json';

export const environment: IEnvironment = {
  production: false,
  appVersion: packageJson.version,
  endpoints: {
    login: '/auth/login',
    ports: '/ports',
    paginatedPorts: '/ports/reports',
    docks: '/docks',
    paginatedShips: '/ships/reports',
    paginatedSpecies: '/species/reports',
    paginatedCaptains: '/captains/reports',
    inspections: '/inspections',
    inspectionsReports: '/inspections/manual/reports/loads',
    resetPassword: '/auth/reset-password',
    refreshToken: '/auth/token-refresh',
    emailConfirmation: '/auth/confirm-email',
    signup: '/user/sign-up',
    userMe: '/user/me',
    forgottenPassword: '/auth/forgotten-password',
    captains: '/captains',
    usersByRole: '/user/user-by-role',
    docksReports: '/docks/reports',
    ships: '/ships',
    shipowners: '/ship-owners',
    processors: '/processors',
    usersInspectors: '/user/inspectors',
    biologists: '/biologists',
    coastguards: '/coastguards',
    inspectionManualReport: '/inspections/manual/json-report/',
    shipsFind: '/ships/find',
    inspectorFind: '/user/find',
    captainFind: '/captains/find',
    dockFind: '/docks/find',
    inspectionUpdate: '/inspections/report',
    findShark: '/species/find/shark/',
    findScale: '/species/find/scale/',
    userClaims: '/user/claims',
    updateUserClaims: '/user/update-claims',
    species: '/species',
    biologicalSamplings: '/biological-sampling/reports',
    biologicalSample: '/biological-sampling/',
    csvBiologicalSample: '/reports/get-csv/biological-sampling',
    csvFID: '/reports/get-csv/loads',
    inspectionsMetrics: '/inspections/metrics',
    csvSharkDetails: '/reports/get-csv/shark-details',
    csvScaleDetails: '/reports/get-csv/scale-details',
    fidPdfReports: '/inspections/manual/pdf-report',
    roles: 'authorization/roles',
    user: 'user',
    types: '/types',
  },
  incopescaDigitalService: {
    apiServer:
      'https://incopesca-digital-dashboard.dev.incopescadigital.com/api',
    // apiServer: 'http://localhost:8080',
  },
};
